module.exports = __webpack_public_path__ + "f1d998a8967e21f6bd277e7cf1600012.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cats/icon-spa@2x.png
// module id = 1754
// module chunks = 0